import { useApolloClient } from '@apollo/client'
import {
  DocumentsDataCollectionDocument,
  DocumentsDocument,
  EmployeeFoldersDocument,
  FoldersDocument,
  ToggleVisibilityDocument,
  ToggleVisibilityMutation,
  ToggleVisibilityMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useToggleVisibilityDocument = () => {
  const client = useApolloClient()
  const [toggleVisibilityMutation, { loading }] = useMutation(ToggleVisibilityDocument, {
    extractorFn: (data: ToggleVisibilityMutation) =>
      data.documentsMutations.toggleVisibilityDocumentsDocument,
  })

  return {
    loading,
    async toggleVisibilityDocument(variables: ToggleVisibilityMutationVariables) {
      const result = await toggleVisibilityMutation({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: DocumentsDocument,
            variables: {
              id: variables.id,
            },
          },
        ],
      })

      client.refetchQueries({
        include: [DocumentsDataCollectionDocument, FoldersDocument, EmployeeFoldersDocument],
      })

      return result
    },
  }
}

export default useToggleVisibilityDocument
